import { useProjectSummary } from '../../hooks/useProjectSummary';
import { emptyTypeBreakdown } from '@overlayqa/shared';
import { ProjectOverview, ProjectOverviewSkeleton } from './ProjectOverview';
import { log } from '@/lib/logger';

interface ProjectChartsSectionProps {
  projectId: string;
}

const EMPTY_SEVERITY = { critical: 0, high: 0, medium: 0, low: 0 };
const EMPTY_TYPE = emptyTypeBreakdown();
const EMPTY_STATUS = { open: 0, 'in-progress': 0, resolved: 0, verified: 0, closed: 0 };
const EMPTY_AGING = { lessThan1d: 0, from1to3d: 0, from3to7d: 0, from7to14d: 0, over14d: 0 };

export function ProjectChartsSection({ projectId }: ProjectChartsSectionProps) {
  const { data, isLoading, error } = useProjectSummary(projectId);

  log.info('[ProjectChartsSection] render', { projectId, isLoading, hasData: data?.hasData, error: !!error });

  // Hide on error — don't block the issues list
  if (error) return null;

  if (isLoading) {
    return <ProjectOverviewSkeleton />;
  }

  const summary = data ? {
    severityBreakdown: data.severityBreakdown ?? EMPTY_SEVERITY,
    typeBreakdown: { ...EMPTY_TYPE, ...(data.typeBreakdown ?? {}) },
    statusBreakdown: { ...EMPTY_STATUS, ...(data.statusBreakdown ?? {}) },
    issueAging: data.issueAging ?? EMPTY_AGING,
  } : null;

  if (!summary) return null;

  return <ProjectOverview key={projectId} data={summary} />;
}
